import { type OverrideToken } from 'antd/es/theme/interface';

/**
 * Permette di sovrascrivere i token di ant relativi ai componenti
 */
export const uiThemeComponentTokens = {
  Layout: {
    headerBg: '#ffffff',
    bodyBg: '#F2F6FA',
  },
  Button: {
    controlOutline: 'none',
  },
  Calendar: {
    itemActiveBg: '#F3F7FA',
  },
  Table: {
    rowHoverBg: '#eaf0f8',
    rowSelectedBg: '#F3F7FA',
    rowSelectedHoverBg: '#eaf0f8',
  },
} satisfies OverrideToken;
